import React from 'react';
import './Slider.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper';
import { SliderProducts } from '../../data/products';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const Slider = () => {
  return (
    <div className="s-container">
      <Swiper
        className="mySlider"
        modules={[Pagination, Navigation]}
        loop={true}
        navigation={true}
        slidesPerGroup={1}
        spaceBetween={20} // Adjust space between slides
        loopFillGroupWithBlank={true}
        breakpoints={{
          1024: {
            slidesPerView: 3, // 3 slides per view for desktop
            spaceBetween: 30,
          },
          768: {
            slidesPerView: 2, // 2 slides per view for tablets
            spaceBetween: 20,
          },
          480: {
            slidesPerView: 1, // 1 slide per view for mobile
            spaceBetween: 10,
          },
        }}
      >
        {SliderProducts.map((slide, i) => (
          <SwiperSlide key={i}>
            <div className="left-s">
              <div className="name">
                <span>{slide.name}</span>
                <span>{slide.detail}</span>
              </div>
              <span>{slide.price}$</span>
              <div className="shop-now">Shop now</div>
            </div>
            <img src={slide.img} alt="product" className="img-products" />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Slider;
